import { useCanWrite } from '@hooks/useCanWrite';
import { DocumentsTable } from '@components/organisms/Documents';

export default function DocumentsPage() {
  // Covers both causes of a locked account: a read-only membership, and an organization
  // whose trial has expired.
  const { canWrite } = useCanWrite();
  const isReadOnly = !canWrite;

  return <DocumentsTable canEdit={true} isReadOnly={isReadOnly} />;
}
